import { createContext, FC, ReactNode, useContext, useState } from 'react';
import { Dialogs } from '../constants/dialogs';

interface DialogContextProps {
  openedDialog: Dialogs | string | null | undefined;
  openDialog: (dialogs: Dialogs | string) => void;
  closeDialog: () => void;
}

const Dialog = createContext<DialogContextProps>({} as DialogContextProps);

export interface DialogProviderProps {
  children: ReactNode;
}

export const DialogProvider: FC<DialogProviderProps> = (props) => {
  const [openedDialog, setOpenedDialog] = useState<Dialogs | string>();
  const openDialog = (dialog: Dialogs | string) => setOpenedDialog(dialog);
  const closeDialog = () => setOpenedDialog(undefined);
  return (
    <Dialog.Provider value={{ openedDialog, openDialog, closeDialog }} {...props}>
      {props.children}
    </Dialog.Provider>
  );
};

export const useDialog = () => useContext(Dialog);
